export const getVersionUrl = (versionId: string, projectKey: string) =>
	`/projects/${projectKey}/versions/${versionId}`;
